import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import SummaryLabelTitle from '../../../summaryLabel/SummaryLabelTitle';
import summaryLabelStyles from '../../../summaryLabel/SummaryLabelStyles';
import SummaryLabelValue from '../../../summaryLabel/SummaryLabelValue';
import Translation from '../../../../../../../../common/components/translation/Translation';
import financeProductsTranslations from '../../../../../../../constants/financeProductsTranslations';

interface ISummaryFinanceProductProps {
  financeProduct: string;
  dataTest: string;
}

const SummaryFinanceProduct: FC<ISummaryFinanceProductProps> = ({ financeProduct, dataTest }) => {
  const styles = summaryLabelStyles();

  return (
    <Grid container={true} justifyContent={'space-between'} spacing={3} className={styles.lineContainer}>
      <SummaryLabelTitle
        label={<Translation id={'trans__configurator__customise_page_finance_details__loan_type_label'} />}
        colSm={8}
        colXs={6}
      />
      <SummaryLabelValue
        text={
          financeProductsTranslations[financeProduct] ? (
            <Translation id={financeProductsTranslations[financeProduct]} />
          ) : (
            ''
          )
        }
        dataTest={dataTest}
        colSm={4}
        colXs={6}
      />
    </Grid>
  );
};

export default SummaryFinanceProduct;
